/* eslint-disable quote-props */

module.exports = {
  'Account security': 'Seguridad de cuenta',
  'Phone was updated': 'El teléfono fue actualizado',
  'Phone is empty': 'El teléfono está vacío',
  'Link is no longer valid': 'El enlace ya no es válido',
  'Invalid link': 'Enlace inválido',
  'Incorrect link': 'Enlace incorrecto',
  'Email was updated': 'Correo electrónico fue actualizado',
  'GO TO LOGIN PAGE': 'IR A LA PÁGINA DE INICIO DE SESIÓN',
  'PURCHASE': 'COMPRAR',
  'SUBSCRIBE': 'SUSCRIBIRSE',
  'Dark Mode': 'Modo Oscuro',
  'Light Mode': 'Modo de Luz',
  'Synonymous': 'Sinónimos',
  'Spintax': 'Spintax',
  'Summarize': 'Resumir',
  'Paraphrase': 'Paráfrasis',
  'Videos': 'Videos',
  'Support': 'Soporte',
  'Payments': 'Pagos',
  'Account': 'Cuenta',
  'Admin': 'Admin',
  'Texts': 'Textos',
  'Synonymous Tool': 'Herramienta Sinónimos',
  'Type or paste your text to generate another with synonymous (500 words maximum)': 'Escriba o pegue su texto para generar otro con sinónimos (máximo 500 palabras)',
  'Protect words (press TAB key to insert)': 'Proteger palabras (presione la tecla TAB para insertar)',
  'Generate text': 'Generar texto',
  'Text copied to clipboard!': 'Texto copiado al portapapeles!',
  'Copy text': 'Copiar texto',
  'Save': 'Guardar',
  'DOWNLOAD PDF': 'DESCARGAR PDF',
  'DOWNLOAD TXT': 'DESCARGAR TXT',
  'DOWNLOAD DOCX': 'DESCARGAR DOCX',
  'DELETE': 'BORRAR',
  'Spintax Tool': 'Herramienta Spintax',
  'Paraphrase Tool': 'Herramienta Paráfrasis',
  'Summarize Tool': 'Herramienta Resumen',
  'Type or paste your text to generate spintax': 'Escriba o pegue su texto para generar spintax',
  'Generate spintax': 'GENERAR SPINTAX',
  'Generate summary': 'GENERAR RESUMEN',
  'Generate paraphrase': 'GENERAR PARÁFRASIS',
  'Spintaxed Text': 'Texto Spintaxado',
  'Enter synonym': 'Ingrese sinónimo',
  'List of synonyms': 'Lista de sinónimos',
  'Synonyms used': 'Sinónimos utilizados',
  'Synonyms removed': 'Sinónimos eliminados',
  'Your Reescrever subscription will be renewed at:': 'Su suscripción a Reescrever se renovará en:',
  'The monthly fee is charged at the beginning of each billing period. Some days may pass before the charge appears in your account.': 'La tarifa mensual se cobra al comienzo de cada período de facturación. Pueden pasar algunos días antes de que el cargo aparezca en su cuenta.',
  'Your Reescrever subscription will be canceled on:': 'Su suscripción a Reescrever se cancelará el:',
  'RESTART SUBSCRIPTION': 'REINICIAR SUSCRIPCIÓN',
  'UNSUBSCRIBE': 'SUSCRIBIRSE',
  'Invoice': 'Factura',
  'Period': 'Periodo',
  'Price': 'Precio',
  'Type': 'Tipo',
  'Description': 'Descripción',
  'NOTE: We only show up to one year of billing history': 'NOTA: Solo mostramos hasta un año de historial de facturación',
  'Set as default': 'Establecer como primario',
  'Add new card': 'Agregar nuevo',
  'Cancel': 'Cancelar',
  'Choose card': 'Elige tarjeta',
  'Delete card': 'Eliminar tarjeta',
  'My cards': 'Mis tarjetas',
  'Before making the payment, we ask that you read and accept the terms of the agreement.': 'Antes de realizar el pago, le pedimos que lea y acepte los términos del acuerdo.',
  'Select credit card': 'Seleccionar tarjeta de crédito',
  'View bank details': 'Ver detalles bancarios',
  'Pay with Paypal': 'Paga con Paypal',
  'REESCREVER AGREEMENT': 'ACUERDO DE REESCREVER',
  'I accept the contract': 'Acepto el contrato',
  'Credit card': 'Tarjeta de crédito',
  'Deposit and transfer': 'Depósito y transferencia',
  'Paypal': 'Paypal',
  'Weekly Plan': 'Plan Semanal',
  'Monthly Plan': 'Plan Mensual',
  'Quarterly Plan': 'Plan Trimestral',
  'Semiannual Plan': 'Plan Semestral',
  'Annual Plan': 'Plan Anual',
  'Unlimited Texts': 'Textos Ilimitados',
  'Artificial intelligence': 'Inteligencia Artificial',
  'Spintax Format': 'Formato Spintax',
  'API': 'API',
  'Copyscape': 'Copyscape',
  'CONTRACT': 'CONTRATO',
  'After paying by PayPal, we ask that you wait up to 24 hours to activate your account.': 'Después de pagar con PayPal, le pedimos que espere hasta 24 horas para activar su cuenta.',
  'I confirm that I have read and accept Reescrever\'s contract': 'Confirmo que he leído y acepto el contrato de Reescrever',
  'Transfer the value of the selected plan to the account:': 'Transfiera el valor del plan seleccionado a la cuenta:',
  'Nu Pagamentos S.A.': 'Nu Pagamentos S.A.',
  'CNPJ: 21.719.922/0001-23': 'CNPJ: 21.719.922/0001-23',
  'GLEIDSON HENRIQUE FRIA 39326490874': 'GLEIDSON HENRIQUE FRIA 39326490874',
  'Agency: 0001': 'Agencia: 0001',
  'Checking account: 52137597-4': 'Cuenta corriente: 52137597-4',
  'After making the deposit / transfer, send us the receipt.': 'Después de realizar el depósito / transferencia, envíenos el recibo.',
  'You must accept the contract!': '¡Necesitas aceptar el contrato!',
  'The voucher was sent successfully!': '¡El comprobante se envió con éxito!',
  'We request a 24-hour period to register the payment in your account. Generally, registration occurs in less time. Any questions, we are available at the email suporte@reescrever.app': 'Solicitamos un período de 24 horas para registrar el pago en su cuenta. Generalmente, el registro ocurre en menos tiempo. Cualquier pregunta, estamos disponibles en el correo electrónico suporte@reescrever.app',
  'Drag and drop voucher here or click to send': 'Arrastre y suelte el comprobante aquí o haga clic para enviar',
  'This file is too large. Please compact it before send.': 'Este archivo es demasiado grande. Compacte antes de enviar.',
  'Enter your credential': 'Para ingresar, ingrese los datos de inicio de sesión:',
  'Email': 'E-mail',
  'Password': 'Contraseña',
  'Forgot your password?': '¿Olvidaste tu contraseña?',
  'Log in': 'Iniciar sesión',
  'Email is required': 'Se requiere correo electrónico',
  'Email invalid': 'Este correo no es valido',
  'Password is required': 'Se requiere contraseña',
  '6 characters minimum': '6 caracteres mínimo',
  '6 characters maximum': '6 characters máximo',
  'Register by filling in the data below': 'Regístrese completando los datos a continuación',
  'Full name': 'Nombre completo',
  'REGISTER': 'REGISTRARSE',
  'Name is required': 'Nombre requerido',
  '2 characters minimum': 'Mínimo 2 caracteres',
  'Create a new password': 'Genera una nueva contraseña',
  'Your new password has been generated and sent to your email. Enter your email to regain access to your Reescrever account.': 'Su nueva contraseña ha sido generada y enviada a su correo electrónico. Ingrese su correo electrónico para recuperar el acceso a su cuenta de Reescrever.',
  'RECOVER ACCOUNT': 'RECUPERAR CUENTA',
  'More videos': 'Más videos',
  'Ooops... looks like an error occurred!': '¡Vaya, parece que se ha producido un error!',
  'Ooops... looks like an error occurred! Try again in a few minutes. If does not work, send this text to our support to analyze the reason for the error.': '¡Vaya ... parece que ocurrió un error! Inténtalo de nuevo en unos minutos. Si no funciona, envíe este texto a nuestro soporte para analizar el motivo del error.',
  'Error code': 'Código de error',
  'GO BACK HOME': 'IR A PÁGINA PRINCIPAL',
  'User data': 'Datos de usuario',
  'Charging and subscription': 'Suscripción y Facturación',
  'Change card': 'Cambiar tarjeta',
  'Change payment method': 'Cambiar método de pago',
  'Charge details': 'Detalles de facturación',
  'Unsubscribe': 'Suscribirse',
  'Change phone': 'Cambiar teléfono',
  'Change email': 'Cambiar correo electrónico',
  'Change password': 'Cambiar contraseña',
  'Name': 'Nombre',
  'Please enter your name': 'Por favor ingrese su nombre.',
  'Occupation': 'Profissão',
  'Please enter your email': 'Por favor ingrese su correo electrónico',
  'Invalid email': 'El correo electrónico no es válido.',
  'Cell phone': 'Móvil',
  'Search': 'Buscar',
  'EXCLUIR': '* Verificación requerida',
  'Current password': 'Contraseña actual',
  'Enter your current password': 'Ingrese su contraseña actual',
  'New password': 'Nueva contraseña',
  'Enter a new password': 'Ingrese nueva contraseña',
  'Confirm password': 'Confirmar seña',
  'Enter your new password': 'Ingrese nueva contraseña',
  'Password doesn\'t match': 'La contraseña es diferente',
  'Your API KEY': 'Su clave API',
  'Change key': 'Cambiar clave',
  'The Reescrever API allows you to integrate Reescrever with your SEO tools for the purpose of automating processes.': 'La API de Reescrever le permite integrar Reescrever con sus herramientas de SEO con el fin de automatizar procesos.',
  'Learn more about API integration': 'Obtenga más información sobre la integración de API',
  'UPDATE': 'ACTUALIZAR',
  'ADD CARD': 'AGREGAR TARJETA',
  'Number card': 'Numero do tarjeta',
  'Name (exactly as on card)': 'Nombre (como en la tarjeta)',
  'Expiring date (MM/AA)': 'Caducidad (MM/AA)',
  'MM/AA': 'MM/AA',
  'CVC': 'CVC',
  'Valid thru': 'Caducidad',
  'Use card as default': 'Usar tarjeta como primaria',
  'Your current Reescrever plan is: Monthly Plan. Subscription expiration and renewal is:': 'Su plan actual de Reescrever es: Plan mensual. El vencimiento y la renovación de la suscripción es:',
  'The monthly fee is charged at the expiration of the subscription. When changing the plan, billing and change to the new plan will only occur after the end of the contracted period. Therefore, the new plan will only come into force on': 'La tarifa mensual se cobra al vencimiento de la suscripción. Al cambiar el plan, la facturación y el cambio al nuevo plan solo ocurrirán después del final del período contratado. Por lo tanto, el nuevo plan solo entrará en vigor el',
  'CHANGE PLAN': 'CAMBIO DE PLAN',
  'Enter to filter questions': 'Ingrese para filtrar preguntas',
  'Write your doubt below': 'Escribe tu pregunta debajo',
  'Write here your question to the Reescrever team...': 'Escriba aquí su pregunta para el equipo de Reescrever ...',
  'Category': 'Categoría',
  'Send question': 'Enviar pregunta',
  'Ok! Thanks.': 'Ok! Gracias.',
  'Send a question': 'Enviar una pregunta',
  'API Key was updated': 'La clave API se actualizó',
  'Name is empty': 'El nombre esta vacio',
  'User data was updated': 'Los datos del usuario fueron actualizados',
  'New email is empty': 'El nuevo correo electrónico está vacío',
  'Verification email has been sent': 'Se ha enviado un correo electrónico de verificación',
  'You must confirm on both emails to make the change': 'Debe confirmar en ambos correos electrónicos para realizar el cambio.',
  'You must confirm your email': 'Debes confirmar tu correo electrónico',
  'Current password is empty': 'La contraseña actual está vacía',
  'New password is empty': 'La nueva contraseña está vacía',
  'Current password must be at least 6 characters': 'La contraseña actual debe tener al menos 6 caracteres',
  'New password must be at least 6 characters': 'La nueva contraseña debe tener al menos 6 caracteres',
  'User password was updated': 'La contraseña del usuario fue actualizada',
  'User not found': 'Usuario no encontrado',
  'Password not match': 'La contraseña no coincide',
  'Email has been confirmed': 'El correo electrónico ha sido confirmado',
  'Email has been updated': 'El correo electrónico ha sido actualizado',
  'E-mail has already been confirmed': 'El correo electrónico ya ha sido confirmado',
  'Current email change confirmed. You now need to confirm the new email.': 'Cambio de correo electrónico actual confirmado. Ahora necesita confirmar el nuevo correo electrónico.',
  'New email change confirmed. You now need to confirm the current email.': 'Cambio de nuevo correo electrónico confirmado. Ahora necesita confirmar el correo electrónico actual.',
  'This is the current email. To change you need to choose another email.': 'Este es el correo electrónico actual. Para cambiar necesita elegir otro correo electrónico.',
  'An SMS code will be sent': 'Se enviará un código de SMS',
  'SMS Code': 'Código SMS',
  'Use {{phoneCode}} to verify your phone on Reescrever': 'Use {{phoneCode}} para verificar su teléfono en Reescrever',
  'Phone is invalid': 'El teléfono no es válido',
  'Phone number is not mobile': 'El número de teléfono no es móvil',
  'Please enter SMS Code': 'Por favor, introduzca el código de SMS',
  'SMS Code is incorrect': 'El código de SMS es incorrecto',
  'Phone has been confirmed and updated': 'El teléfono ha sido confirmado y actualizado',
  'SMS code has been sent': 'El código de SMS ha sido enviado',
  '* Confirm your phone with SMS code sent.': '* Confirme su teléfono celular con el código SMS enviado.',
  'SMS code has been resent': 'El código SMS ha sido reenviado',
  'Not a phone number': 'No es un numero de telefono',
  'Phone must be different from the current one': 'El teléfono debe ser diferente del actual',
  'Click to copy the API': 'Haga clic para copiar la API',
  'API Key was copied to the clipboard': 'La clave API se copió al portapapeles',
  'Please enter credit card number': 'Ingrese su número de tarjeta de crédito',
  'Please enter credit card name': 'Ingrese el nombre de la tarjeta de crédito',
  'Please enter credit card expiration': 'Ingrese el vencimiento de la tarjeta de crédito',
  'Please enter credit card CVV': 'Introduzca la tarjeta de crédito CVV',
  '12 number minimum': 'Mínimo 12 números',
  '13 number minimum': 'Mínimo 13 números',
  '14 number minimum': 'Mínimo 14 números',
  '15 number minimum': 'Mínimo 15 números',
  '16 number minimum': 'Mínimo 16 números',
  '17 number minimum': 'Mínimo 17 números',
  '18 number minimum': 'Mínimo 18 números',
  '19 number minimum': 'Mínimo 19 números',
  '20 number minimum': 'Mínimo 20 números',
  '3 number minimum': 'Mínimo 3 números',
  '4 number minimum': 'Mínimo 4 números',
  'Phone is already used by another user': 'El teléfono ya está siendo usado por otro usuario',
  'Contract must be accept': 'El contrato debe ser aceptado',
  'Preferred': 'Preferido',
  'Define as preferred': 'Definir como preferido',
  'ADD PAYPAL': 'AGREGAR PAYPAL',
  'Recurring payment': 'Pago recurrente',
  'Actions': 'Acciones',
  'Delete': 'Eliminar',
  'Show card data': 'Mostrar datos de la tarjeta',
  'cardID is empty': 'CardID está vacío',
  'Error changing default payment': 'Error al cambiar el pago preferido',
  'Error removing payment': 'Error al eliminar el pago',
  'Expiry date is invalid': 'Ingrese el vencimiento de la tarjeta de crédito',
  'Expiry month should be between 01 and 12': 'El mes debe ser entre 01 y 12',
  'Expiry year cannot be in the past': 'El año debe ser igual o mayor que el actual',
  'Card expired': 'La tarjeta ha caducado',
  'Card is invalid': 'La tarjeta no es válida',
  'Already have an account?': '¿Ya tienes una cuenta?',
  'Don\'t have an account yet?': '¿Aún no tienes una cuenta?',
  'Sign in': 'Iniciar sesión',
  'Sign up': 'Crear una cuenta',
  'Add a credit card or paypal': 'Agregar una tarjeta de crédito o paypal',
  'You don\'t have an added form of payment yet. First add a credit card or link your paypal account for a recurring subscription.': 'Aún no tiene una forma de pago adicional. Primero agregue una tarjeta de crédito o vincule su cuenta de PayPal para una suscripción recurrente.',
  'Transfer receipts': 'Transferencia de recibos',
  'Delete transfer receipt': 'Eliminar recibo de transferencia',
  'The voucher must be deleted only if you are sure that the payment has not occurred and that it will not actually happen.': 'El comprobante debe eliminarse solo si está seguro de que el pago no se ha producido y de que no se realizará.',
  'Generally, transfers can take up to 3 days to appear. If it has already passed and has not yet appeared, it may be that some of the data is wrong or that the user made an appointment instead of transferring.': 'En general, las transferencias pueden tardar hasta 3 días en aparecer. Si ya pasó y aún no ha aparecido, puede ser que algunos de los datos estén incorrectos o que el usuario haya hecho una cita en lugar de transferirlos.',
  'When deleting the receipt, an email will be sent to the user.': 'Al eliminar el recibo, se enviará un correo electrónico al usuario.',
  'Are you sure you want to proceed?': '¿Estás seguro de que quieres continuar?',
  'Yes': 'Si',
  'No': 'No',
  'Find users and logs': 'Encuentra usuarios y registros',
  'Delete payment method': 'Eliminar forma de pago',
  'When you delete the payment method, it will no longer be used. You can add it again if you wish.': 'Cuando elimine su forma de pago, ya no se utilizará. Puede agregarlo nuevamente si lo desea.',
  'Since this is the preferred payment method, when it is deleted, another random payment method will be set as preferred. If desired, you can define another preferred payment method before or after deletion.': 'Como esta es la forma de pago preferida, cuando se elimina, otra forma de pago aleatoria se definirá como preferida. Si lo desea, puede definir otra forma de pago preferida antes o después de la eliminación.',
  'As it is the only payment method, the subscription will be canceled and will not be renewed later, thus causing the Reescrever to be interrupted before you finish your job. Your subscription will only be active until the end of the paid period.': 'Como es la única forma de pago, la suscripción se cancelará y no se renovará más tarde, lo que provocará la interrupción del Reescrever antes de que finalice su trabajo. Su suscripción solo estará activa hasta el final del mes pagado.',
  'Regular price': 'Precio regular',
  '10% off': '10% de descuento',
  '20% off': '20% de descuento',
  '30% off': '30% de descuento',
  'Account balance': 'Saldo de cuenta',
  'Add balance': 'Agregar saldo',
  'Bank transfer': 'Transferencia bancaria',
  'You can add balance to your account through Bank Billet and Bank Transfer and use it to sign up for Reescrever, without needing a credit card.': 'Puede agregar saldo a su cuenta usando Boleto y Transferencia bancaria y usarlo para registrarse en Reescrever, sin necesidad de una tarjeta de crédito.',
  'How do you prefer to add balance?': '¿Cómo prefiere agregar el saldo?',
  'Bank billet': 'Factura bancaria',
  'Transfer': 'Transferencia',
  'Delete text': 'Eliminar texto',
  'After deleting the text, it will no longer be possible to obtain it again.': 'Después de eliminar el texto, ya no será posible obtenerlo nuevamente.',
  'Make sure you have a copy in a safe place before deleting.': 'Asegúrese de tener una copia en un lugar seguro antes de eliminarla.',
  'Spinned text was updated': 'Texto Spinneado ha sido actualizado',
  'Text was updated': 'Texto ha sido actualizado',
  'The spinning process is taking place. At the moment, this process is taking too long, in some cases even more than 5 minutes. So be patient. If an error occurs, you will be informed.': 'El proceso de spinnear está teniendo lugar. Por el momento, este proceso está tardando demasiado, en algunos casos incluso más de 5 minutos. Sé paciente. Si se produce un error, se le informará.',
  'Your paraphrased text is being generated': 'Se está generando su texto parafraseado',
  'Rephrase': 'Reformular la oración',
  'OriginalSentence': 'Oración original',
  'NEW': 'NUEVO',
  'NEW TEXT': 'NUEVO TEXTO',
  'Are you sure?': '¿Estas seguro?',
  'Make sure you have saved text before proceeding. It will not be possible to recover it.': 'Asegúrese de haber guardado el texto antes de continuar. No será posible recuperarlo.',
  'E-mail already registered': 'Correo electrónico ya registrado',
  'User no longer exists': 'El usuario ya no existe',
  'E-mail has been updated previously. Nothing has been accomplished now.': 'El correo electrónico se ha actualizado previamente. Ahora no se ha logrado nada.',
  'It is currently possible to paraphrase only in Portuguese': 'Actualmente es posible parafrasear solo en portugués',
  'Validate your email to be able to use Reescrever. A welcome email with a validation button was sent to': 'Valide su correo electrónico para poder utilizar Reescrever. Se ha enviado un correo electrónico de bienvenida con un botón de validación a:',
  'Select a phrase before generating a new paraphrase': 'Seleccione una frase antes de generar una nueva paráfrasis',
  'Copy': 'Copiar',
  'Text was copied to the clipboard': 'El texto se copió en el portapapeles',
  'The limit is 300 words for the free plan': 'El límite es de 300 palabras para el plan gratuito',
  'The limit is 1000 words for the free plan': 'El límite es de 1000 palabras para el plan gratuito',
  'The limit is 2000 words for paid plans': 'El límite es de 2000 palabras para el plan pago',
  'The limit is 5000 words for paid plans': 'El límite es de 5000 palabras para el plan pago',
  'An error occurred while copying the text': 'Ocurrió un error al copiar el texto',
};
